import React, { createContext, useContext } from 'react'

interface PreviewContextType {
  isPreview: boolean
}

const PreviewContext = createContext<PreviewContextType>({
  isPreview: false,
})

export const usePreview = () => useContext(PreviewContext)

export const PreviewProvider = ({
  children,
  isPreview = false,
}: {
  children: React.ReactNode
  isPreview?: boolean
}) => {
  return <PreviewContext.Provider value={{ isPreview }}>{children}</PreviewContext.Provider>
}
